import { render, staticRenderFns } from "./DeparmentEdit.vue?vue&type=template&id=463199f5&"
import script from "./DeparmentEdit.vue?vue&type=script&lang=js&"
export * from "./DeparmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./DeparmentEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports